const CHANGE_PASSWORD_REQUEST = 'USER_CHANGE_PASSWORD_REQUEST'
const CHANGE_PASSWORD_SUCCESS = 'USER_CHANGE_PASSWORD_SUCCESS'
const CHANGE_PASSWORD_FAILURE = 'USER_CHANGE_PASSWORD_FAILURE'
const LOGIN_REQUEST = 'USER_LOGIN_REQUEST'
const LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
const LOGIN_FAILURE = 'USER_LOGIN_FAILURE'
const REGISTER_REQUEST = 'USER_REGISTER_REQUEST'
const REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS'
const REGISTER_FAILURE = 'USER_REGISTER_FAILURE'
const FORGOT_PASSWORD_REQUEST = 'USER_FORGOT_PASSWORD_REQUEST'
const FORGOT_PASSWORD_SUCCESS = 'USER_FORGOT_PASSWORD_SUCCESS'
const FORGOT_PASSWORD_FAILURE = 'USER_FORGOT_PASSWORD_FAILURE'
const SET_PASSWORD_REQUEST = 'USER_SET_PASSWORD_REQUEST'
const SET_PASSWORD_SUCCESS = 'USER_SET_PASSWORD_SUCCESS'
const SET_PASSWORD_FAILURE = 'USER_SET_PASSWORD_FAILURE'
const VERIFY_PHONE_FAILURE = 'USER_VERIFY_PHONE_FAILURE'
const VERIFY_EMAIL_FAILURE = 'USER_VERIFY_EMAIL_FAILURE'
const DEACTIVATE_FAILURE = 'USER_DEACTIVATE_FAILURE'
const SESSION_USER_REQUEST = 'USER_SESSION_USER_REQUEST'
const SESSION_USER_SUCCESS = 'USER_SESSION_USER_SUCCESS'
const SESSION_USER_FAILURE = 'USER_SESSION_USER_FAILURE'
const UPDATE_REQUEST = 'USER_UPDATE_REQUEST'
const UPDATE_USER_SUCCESS = 'USER_UPDATE_SUCCESS'
const UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS'
const UPDATE_FAILURE = 'USER_UPDATE_FAILURE'
const LOGOUT = 'USER_LOGOUT'
const SECURITY_BLOCKED = 'SECURITY_BLOCKED'
const CLEAR_STATE = 'CLEAR_STATE'
const INCAPSULA_CAPTCHA = 'INCAPSULA_CAPTCHA'

export default {
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  REGISTER_FAILURE,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  SET_PASSWORD_REQUEST,
  SET_PASSWORD_SUCCESS,
  SET_PASSWORD_FAILURE,
  VERIFY_PHONE_FAILURE,
  DEACTIVATE_FAILURE,
  SESSION_USER_REQUEST,
  SESSION_USER_SUCCESS,
  SESSION_USER_FAILURE,
  UPDATE_USER_SUCCESS,
  UPDATE_REQUEST,
  UPDATE_SUCCESS,
  UPDATE_FAILURE,
  LOGOUT,
  SECURITY_BLOCKED,
  CLEAR_STATE,
  VERIFY_EMAIL_FAILURE,
  INCAPSULA_CAPTCHA,
}
